<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="800px">
    <v-card>
      <v-card-title>
        <v-row>
          <v-col>
            Delete {{ track.name }} track?
          </v-col>
          <v-col class="text-right">
            <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
          <v-btn @click="close" text>Nevermind</v-btn>
        <v-btn @click="deleteTrack" color="error"
          >Yes, Delete it!</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: ['value', 'track'],
    data() {
      return {
        isOpen: false,
        deletingTrack: {},
      };
    },

    computed: {
    },

    watch: {
      value(val) {
        if (val) {
          this.deletingTrack = this.track
        } else {
          this.reset();
        }
      },
    },

    methods: {
      close() {
        this.reset();
        this.$emit('input', false);
      },
      reset() {
        this.deletingTrack = {}
      },
      deleteTrack() {
        this.$store.dispatch('progress/deleteProgressTrack', this.deletingTrack)
        this.close()
      }

    },
  };
</script>
